"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Monitor = void 0;
const VizzlyApiClientLogger_1 = require("./VizzlyApiClientLogger");
class Monitor {
    static timeRequest(method, path, asyncFunction) {
        return function (...args) {
            return __awaiter(this, void 0, void 0, function* () {
                const start = performance.now();
                const result = yield asyncFunction(...args);
                const stop = performance.now();
                const duration = stop - start;
                VizzlyApiClientLogger_1.VizzlyApiClientLogger.debug(`[@vizzly/api-client timing] ${method.toUpperCase()} ${path} - ${duration.toFixed(2)}ms`);
                return result;
            });
        };
    }
}
exports.Monitor = Monitor;
